(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsCardIcon', ['CardIconMap', 'CardRegistry', function (CardIconMap, CardRegistry) {
    var defaultIconMap = {
      "activity": "activity",
      "me": "user"
    };
    return {
      template: '<svg class="svg-sprite primary"><use xlink:href="" /></svg>',
      replace: true,
      scope: {
        cardTemplate: "=?",
        cardId: "=?",
        color: "=?"
      },
      link: function link(scope, elem) {
        var iconClass = null;

        //if cardId provided instead of template, get template info
        if (!scope.cardTemplate && scope.cardId) {
          scope.cardTemplate = CardRegistry.get(scope.cardId).template;
        }

        //use template info to get card icon otherwise use a default value
        if (scope.cardTemplate) {
          var templateName = scope.cardTemplate.name;

          // If this template name has a hash, it's an old
          // custom template that has been migrated
          if (templateName.indexOf("#") >= 0) {
            var nameParts = templateName.split("#");
            templateName = nameParts[1];
          }
          iconClass = CardIconMap.getIcon(templateName) || defaultIconMap[scope.cardTemplate.cardType] || "activity";
        }
        if (scope.color) {
          elem.removeClass('primary');
          elem.addClass(scope.color);
        }
        elem.children().attr('xlink:href', '#' + (iconClass || "activity"));
      }
    };
  }]);
})();
